import { put, all, select } from "redux-saga/effects";
import { cloneDeep } from "lodash";

import getErrorActions from "rdx/utils/getErrorActions";
import makeRequest from "rdx/utils/makeRequest";
import actions from "rdx/actions";
import preSalesSelectors from "rdx/modules/projectPreSales/selectors";
import { orgProjectsApi } from "rdx/modules/enterpriseProjects/endpoints";
import { ORG_PROJECTS_TAGS } from "rdx/modules/enterpriseProjects/tags";
import { keysToCamelCase } from "lib/helpers";
import messages from "../messages";

function* reopenLead(action) {
  const { id } = action.payload;

  const { success, data, error } = yield* makeRequest.post(`/leads/${id}/reopen`, {});
  if (success && data) {
    const leadDetails = keysToCamelCase(data.body);
    const { projects: presalesProjects, paging: presalesPaging } = yield select(preSalesSelectors.getProjectPreSales);
    const idxOfUpdatedLead = presalesProjects.findIndex((proj) => proj.leadId === parseInt(id, 10));
    const updatedPreSales = cloneDeep(presalesProjects);
    updatedPreSales[idxOfUpdatedLead] = {
      ...updatedPreSales[idxOfUpdatedLead],
      closeAt: leadDetails.closeAt,
      closeReasonId: leadDetails.closeReasonId,
    };

    yield all([
      put(actions.setLeadDetails(leadDetails)),
      put(actions.setProjectClosedBannerActive(false)),
      put(actions.setAdminProjectReopened()),
      put(actions.setProjectReopened()),
      put(
        actions.setProjectsPreSales({
          projects: updatedPreSales,
          paging: presalesPaging,
        }),
      ),
      yield put(orgProjectsApi.util.invalidateTags([ORG_PROJECTS_TAGS.ORG_PRE_SALES_PROJECTS])),
      put(
        actions.newSuccessEvent({
          message: messages.REOPEN_LEAD_SUCCESS,
        }),
      ),
    ]);
  } else {
    return getErrorActions({
      error,
      message: messages.ERROR_REOPENING_LEAD,
    });
  }
  return null;
}

export default reopenLead;
